import { useEffect } from 'react';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import { appActions } from '#reducers/app.reducer';
import Header from '../header/Header.react';
import Routes from './routing/Routes.react';
import Footer from '../footer/Footer.react';
import Sidebar from '../sidebar/Sidebar.react';
import ScrollListener from '../common/ScrollListener.react';
import Modal from '../modal/Modal.react';
import MobileMenu from '../mobile-menu/MobileMenu.react';
import EventListener from './EventListener.react';
import Calculator from '../calculator/Calculator.react';
import Preload from './Preload.react';
import Notification from '../notification/Notification.react';
import ContactUsBubble from '../contact-us-bubble/ContactUsBubble.react';
var App = function App(_ref) {
  var booted = _ref.booted,
    bootAction = _ref.bootAction;
  useEffect(function () {
    bootAction();
    ReactGA.initialize('UA-175488832-3');
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Preload, null), booted && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(Routes, null), /*#__PURE__*/React.createElement(Footer, null), /*#__PURE__*/React.createElement(Sidebar, null), /*#__PURE__*/React.createElement(ScrollListener, null), /*#__PURE__*/React.createElement(Modal, null), /*#__PURE__*/React.createElement(MobileMenu, null), /*#__PURE__*/React.createElement(EventListener, null), /*#__PURE__*/React.createElement(Calculator, null), /*#__PURE__*/React.createElement(Notification, null), /*#__PURE__*/React.createElement(ContactUsBubble, null)));
};
var mstp = function mstp(s) {
  return {
    booted: s.app.booted
  };
};
var mdtp = {
  bootAction: appActions.boot
};
export default connect(mstp, mdtp)(App);